import {Component, OnDestroy, OnInit, ViewChild, EventEmitter, Output, OnChanges} from '@angular/core';
import {CurrencySettingModel} from '../../../models/CurrencySettingModel';
import {CurrencySettingService} from './service/currency-setting.service';
import {MatDialog, MatPaginator, MatSort, MatTableDataSource, PageEvent, Sort} from '@angular/material';
import {forkJoin, Observable, Subscription} from 'rxjs';
import {DialogDetailComponent} from '../../general-components/dialog-detail/dialog-detail.component';
import * as toastr from 'toastr';
import {GenericArray} from '../../../models/GenericArray';
import {Offset} from '../../../models/Offset';
import {BaseGeneralComponent} from '../../BaseGeneralComponent';
import {LoaderService} from '../../general-services/service-loader/loader.service';
import { Router } from '@angular/router';
import {UsersService} from '../../users/service/users.service';

@Component({
  selector: 'app-currency',
  templateUrl: './currency.component.html',
  styleUrls: ['./currency.component.scss']
})
export class CurrencyComponent extends BaseGeneralComponent implements OnInit, OnChanges, OnDestroy {

  sectionId: string;

  displayedColumns: Array<string>;
  dataSource: any;
  isCurrencySection: boolean;
  selectedRowIndex: number;
  listData: MatTableDataSource<any>;
  getAllSubscribe: Subscription;
  deleteElementSubscribe: Subscription;

  filter: CurrencySettingModel;
  offset: Offset;
  showNewEditDelete: boolean;
  showFilter: boolean;

  @ViewChild(MatSort) sort: MatSort;
  @ViewChild(MatPaginator) paginator: MatPaginator;

  @Output() elementSelected = new EventEmitter();



  constructor(private currencySettingService: CurrencySettingService,
              private userService: UsersService,
              public dialog: MatDialog,
              private loaderService: LoaderService,
              private router: Router) {
    super();
    this.loaderService.display(true);
    this.user = JSON.parse(sessionStorage.getItem('user'));
    this.sectionId = this.SECTIONS.SETTINGS;
    this.filter = new CurrencySettingModel();
  }

  ngOnInit() {
    this.isCurrencySection = this.returnIsContractSection(this.router.url);
    this.showNewEditDelete = !this.checkRole();
    this.showFilter = false;
    this.selectedRowIndex = -1;

    this.displayedColumns = ['regionDesc', 'currencyDesc', 'actions'];

    this.offset = this.setOffsetInSession(this.offset, this.OFFSET_NAME.CURRENCY_SETTING_OFFSET);
    this.userService.getUserSectionGrant(this.user.id, this.sectionId).subscribe(
      (result: any) => {
        this.setUserGrants(result);
      });
    this.getSessionStorageFilter();
    this.getDataPage(this.offset, this.filter);
  }

  ngOnChanges() {
  }

  getDataPage(offset: Offset, filter: CurrencySettingModel) {
    this.getAllSubscribe = this.currencySettingService.getPage(offset, filter)
      .subscribe(
        (result: any) => {
          this.dataSource = result.content;
          this.listData = new MatTableDataSource(this.dataSource);
          this.listData.sort = this.sort;
          this.paginator.pageIndex = offset.pageIndex;
          this.paginator.showFirstLastButtons = true;
          this.paginator.length = result.totalElements;
          this.loaderService.display(false);
        });
  }

  openDialog(currency: any, region: any) {
    const contractData = this.dataSource.find(data => data.currency.cod === currency.cod
                                                    && data.region.cod === region.cod) as CurrencySettingModel;
    const list: GenericArray[] = [
      {id: 'Region Cod', value: this.toCustomString(contractData.region.cod)},
      {id: 'Region Description', value: this.toCustomString(contractData.region.description)},
      {id: 'Currency Cod', value: this.toCustomString(contractData.currency.cod)},
      {id: 'Currency Description', value: this.toCustomString(contractData.currency.description)}
    ];
    const dialogRef = this.dialog.open(DialogDetailComponent, {
      width: '40%',
      data: {list}
    });

    dialogRef.afterClosed().subscribe(result => {
      // console.log('The dialog was closed');
    });

  }

  getNext(event: PageEvent) {
    this.loaderService.display(true);
    const tmpOffset = new Offset(event.pageSize, event.pageIndex);
    this.setOffsetInSession(tmpOffset, this.OFFSET_NAME.CURRENCY_SETTING_OFFSET);
    tmpOffset.orderDirection = this.offset.orderDirection;
    tmpOffset.orderField = this.offset.orderField;
    this.offset = tmpOffset;
    this.getDataPage(this.offset, this.filter);
  }

  deleteElement(id: number) {
    if (confirm('Are you sure do you want to delete?')) {
      this.deleteElementSubscribe = this.currencySettingService.softDelete(id)
        .subscribe(
          (result: any) => {
            if (result) {
              toastr.success('Currency with id ' + id + ' was deleted with success', 'Success');
              this.getDataPage(this.offset, this.filter);
            } else {
              toastr.info('Currency cannot be deleted', 'Alert');
            }
            this.loaderService.display(false);
          }, error =>  {
            toastr.error('Currency with id ' + id + ' was not deleted', 'Error');
            this.loaderService.display(false);
          }
        );
    }
  }

  getDataFiltered(filter: CurrencySettingModel) {
    this.filter = filter;
    if (this.offset === null || this.offset === undefined) {
      this.offset = new Offset(10, 0);
    }
    this.filter = filter;
    this.getDataPage(this.offset, this.filter);
  }

  sortData(sort: Sort) {
    this.loaderService.display(true);
    if ((sort.active !== null || true || sort.active !== '') && (sort.direction !== '' || sort.direction !== null || true)) {
      if (this.offset === null || this.offset === undefined) {
        this.offset = new Offset(10, 0);
      }

      this.offset.orderField = sort.active;
      this.offset.orderDirection = sort.direction;

      this.getDataPage(this.offset, this.filter);
    }
  }

  selectRow(row: any) {
    this.selectedRowIndex = row.id;
    this.elementSelected.emit({ row });
  }

  ngOnDestroy(): void {
    if (this.getAllSubscribe) {
      this.getAllSubscribe.unsubscribe();
    }
    if (this.deleteElementSubscribe) {
      this.deleteElementSubscribe.unsubscribe();
    }
  }

  toggleFilter() {
    this.showFilter = !this.showFilter;
  }

  getSessionStorageFilter() {
    const filter_ = JSON.parse(sessionStorage.getItem(this.SESSION_STORAGE_LABELS.CURRENCY_SETTING_FILTER));
    this.filter = filter_ ? filter_ : new CurrencySettingModel();
  }
}
